const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8015/api/v1";

const STREAM_BASE_URL =
  process.env.REACT_APP_STREAM_BASE_URL || "http://localhost:8015";

export { API_BASE_URL, STREAM_BASE_URL };
